import i18next from 'i18next'
import type { SystemAppointmentCancellationReason } from 'constants/'
import { PrimaryAppointmentCancellationReason, PrimaryAppointmentCancellationReasonDE } from 'components/Appointment/Cancellation/utils'
import { PrimaryAppointmentRescheduleReason, PrimaryAppointmentRescheduleReasonDE } from '../../../../Reschedule/utils'

type RescheduleReasonKey = keyof typeof PrimaryAppointmentRescheduleReason | PrimaryAppointmentRescheduleReasonDE

const rescheduleReasonDisplayText: Record<RescheduleReasonKey, string> = Object.freeze({
  CUSTOMER_NOT_AVAILABLE: i18next.t('pages.appointment.reschedule.reason.customerNotAvailable'),
  OTHER: i18next.t('pages.appointment.reschedule.reason.other'),
  TECH_SETUP_FAILED: i18next.t('pages.appointment.reschedule.reason.techSetupFailed'),
  WAX_OCCLUSION: i18next.t('pages.appointment.reschedule.reason.waxOcclusion'),
  PROVIDER_ILLNESS: i18next.t('pages.appointment.reschedule.reason.providerIllness'),
  PROVIDER_UNAVAILABLE: i18next.t('pages.appointment.reschedule.reason.providerUnavailable'),
  CUSTOMER: i18next.t('pages.appointment.reason.customer'),
  PARTNER: i18next.t('pages.appointment.reason.partner'),
  TECH: i18next.t('pages.appointment.reason.tech'),
  TECH_SETUP_INCOMPLETE: i18next.t('pages.appointment.reason.techSetupIncomplete'),
})

type CancellationReasonKey = keyof typeof PrimaryAppointmentCancellationReason | PrimaryAppointmentCancellationReasonDE

const cancellationReasonDisplayText: Record<CancellationReasonKey | SystemAppointmentCancellationReason, string> = Object.freeze({
  CUSTOMER_NOT_INTERESTED: i18next.t('pages.appointment.cancel.reason.customerNotInterested'),
  TECH_SETUP_FAILED: i18next.t('pages.appointment.cancel.reason.techSetupFailed'),
  OTHER: i18next.t('pages.appointment.cancel.reason.other'),
  SYSTEM_ROLLBACK: i18next.t('pages.appointment.reason.systemRollback'),
  SYSTEM_OUTAGE: i18next.t('pages.appointment.reason.systemOutage'),
  CUSTOMER: i18next.t('pages.appointment.reason.customer'),
  PARTNER: i18next.t('pages.appointment.reason.partner'),
  TECH: i18next.t('pages.appointment.reason.tech'),
  TECH_SETUP_INCOMPLETE: i18next.t('pages.appointment.reason.techSetupIncomplete'),
})

export { cancellationReasonDisplayText, rescheduleReasonDisplayText }
